import React from 'react';
import { FadeIn } from './FadeIn';
import { Star, Quote } from 'lucide-react';
import { motion } from 'framer-motion';
export function TestimonialsSection() {
  const testimonials = [{
    quote: 'Hice el Bike Fit con el Tomo 2 y el dolor de rodilla que tenía hace 8 meses desapareció en la primera semana. No puedo creer que antes pagaba $60.000 en el ortopedista.',
    author: 'Martín G.',
    location: 'Ciclista de ruta · Buenos Aires',
    initial: 'M'
  }, {
    quote: 'Antes perdía $80.000 por mes en el taller. Ahora hago todo yo. En 3 meses recuperé lo que pagué por el sistema.',
    author: 'Roberto S.',
    location: 'MTB trail · Mendoza',
    initial: 'R'
  }, {
    quote: 'Subí 22 vatios de FTP en 10 semanas siguiendo el plan del Tomo 3. Sin entrenador, sin potenciómetro caro.',
    author: 'Diego F.',
    location: 'Ciclista amateur · Rosario',
    initial: 'D'
  }, {
    quote: 'Los geles caseros del Bono 1 son una revolución. Ahorro $35.000 por mes y rindo igual o mejor.',
    author: 'Lucía M.',
    location: 'Ciclista de ruta y gravel · Córdoba',
    initial: 'L'
  }, {
    quote: 'El kit de emergencia del Bono 2 me salvó a 60km de casa. Cambié la cadena rota en 8 minutos y llegué pedaleando.',
    author: 'Andrés P.',
    location: 'MTB enduro · Salta',
    initial: 'A'
  }, {
    quote: 'Nunca pensé que iba a poder purgar los frenos yo solo. Lo hice con el Tomo 6 y quedaron mejor que cuando los llevé al taller.',
    author: 'Facundo R.',
    location: 'Ciclista ruta · Santa Fe',
    initial: 'F'
  }];
  const Stars = () => <div className="flex gap-1 md:gap-1.5 text-[#22c55e] mb-3 md:mb-6" data-id="element-360">
      {[...Array(5)].map((_, i) => <Star key={i} fill="currentColor" className="drop-shadow-[0_0_5px_rgba(34,197,94,0.3)] w-4 h-4 md:w-5 md:h-5" data-id="element-361" />)}
    </div>;
  return <section className="py-8 md:py-20 px-4 max-w-6xl mx-auto bg-[#f8fafc]" data-id="element-362">
      <FadeIn data-id="element-363">
        <h2 className="text-2xl md:text-5xl font-black text-[#0f172a] text-center mb-6 md:mb-14 flex items-center justify-center gap-2 md:gap-4 px-2" data-id="element-364">
          <span className="text-[#ef4444] drop-shadow-[0_0_15px_rgba(239,68,68,0.2)]" data-id="element-365">
            ❤️
          </span>{' '}
          LO QUE DICEN LOS QUE YA LO TIENEN
        </h2>
      </FadeIn>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-8" data-id="element-366">
        {testimonials.map((t, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-367">
            <motion.div whileHover={{
          y: -5
        }} className="bg-white border border-[#e2e8f0] hover:border-[#22c55e]/50 rounded-2xl md:rounded-3xl p-5 md:p-8 h-full relative overflow-hidden shadow-sm hover:shadow-md transition-all" data-id="element-368">
              <Quote className="absolute top-4 right-4 md:top-6 md:right-6 text-[#f1f5f9] w-16 h-16 md:w-24 md:h-24 rotate-180 -z-0" data-id="element-369" />

              <div className="relative z-10 flex flex-col h-full" data-id="element-370">
                <Stars data-id="element-371" />
                <p className="text-base md:text-xl text-[#0f172a] mb-4 md:mb-8 italic leading-relaxed font-medium flex-grow" data-id="element-372">
                  "{t.quote}"
                </p>
                <div className="flex items-center gap-3 md:gap-4 mt-auto pt-4 md:pt-6 border-t border-[#e2e8f0]" data-id="element-373">
                  <div className="w-10 h-10 md:w-12 md:h-12 bg-gradient-to-br from-[#22c55e] to-[#4ade80] rounded-full flex items-center justify-center text-[#020617] font-black text-base md:text-xl shadow-[0_5px_15px_rgba(34,197,94,0.3)]" data-id="element-374">
                    {t.initial}
                  </div>
                  <div data-id="element-375">
                    <p className="font-black text-[#0f172a] text-base md:text-lg" data-id="element-376">
                      {t.author}
                    </p>
                    <p className="text-xs md:text-sm text-[#475569] font-bold" data-id="element-377">
                      {t.location}
                    </p>
                  </div>
                </div>
              </div>
            </motion.div>
          </FadeIn>)}
      </div>
    </section>;
}